import { HttpClinet, baseURL, version } from "./../utils/config";

export const promotionAPI = {
  getPromotion: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/promotion/getPromotion`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...data },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getPromotionExcel: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/promotion/getPromotionExcel`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...data },
      responseType: "blob",
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  },
  getPromotionById: (_id) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/promotion/getPromotionById/${_id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
};
